module.exports = __webpack_public_path__ + "static/media/CHANGELOG.00a5b958.md";